import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAkOdePosInsatallment } from '../models/models'

export class ListAkOdePosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionAkOde/listAkOdePosInsatallment',
      requesterInfo,
    })
  }

  public async listAkOdePosInsatallment(): Promise<IAkOdePosInsatallment[]> {
    return await this.getAsync<IAkOdePosInsatallment[]>()
  }
}

